var r=r=>{const t=r?.status;if(t>=500&&t<600)throw r};export{r as throwServerError};
//# sourceMappingURL=throwServerError.js.map